<template>
	<div class="momentsMain">
		<mainLeft :info="info" />
		<mainRight />
	</div>
</template>

<script>
	import mainLeft from './mainLeft'
	import mainRight from './mainRight'

	export default {
		props:{
			info:{
				required:false,
				type:Object
			}
		},
		components: {
			mainLeft,
			mainRight
		}
	}
</script>

<style scoped>
	.momentsMain {
		width: 1300px;
		margin: auto;
		overflow: hidden;
	}
</style>
